import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { auth } from '@/firebase/config'

// import pinia
import { createPinia } from 'pinia'

// import i18n
import i18n from './i18n'

// import my own global css
import '@/assets/globalStyle.css'
// '@/index.css' is tailwind
import '@/index.css'
import 'flowbite'
import 'primeicons/primeicons.css'
import PrimeVue from 'primevue/config'
import Lara from '@primevue/themes/lara'
import Tooltip from 'primevue/tooltip'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'

// primevue import end

/**
 * import Cropper image lib
 */
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
/**
 * import Cropper image lib End
 */

//init app
let app

// onAuthStateChanged(auth, (userDetails) => {
//     app.mount('#app')
// })
auth.onAuthStateChanged((user) => {
    console.log('Auth state changed:', user)
    if (!app) {
        console.log('Creating app...')
        app = createApp(App)
        app.use(createPinia())
        // onAuthStateChanged(auth, (userDetails) => {
        app.use(router)

        // Add i18n to the application
        app.use(i18n)

        /**
         * PrimeVue from
         */
        app.use(PrimeVue, {
            theme: {
                preset: Lara,
                options: {
                    darkModeSelector: '.prime-dark'
                }
            }
        })
        app.use(ToastService)
        app.use(ConfirmationService)

        app.directive('tooltip', Tooltip)

        /**
         * PrimeVue from end
         */
        //import Cropper image lib
        app.component('Cropper', Cropper)
        //import Cropper image lib end

        console.log('Mounting app...')
        app.mount('#app')
    }
})
